/**
 * tc-sections.js — TextureCrush Homepage Sections
 * Isolated IIFE — zero global scope pollution.
 * Relies on Dawn's SliderComponent (global.js) for carousel behaviour.
 */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     HAIR STORIES — Drag-to-scroll (desktop fallback)
     SliderComponent handles touch/swipe natively.
     We add mouse-drag on desktop for the custom track.
  ---------------------------------------------------------- */
  function initHairStoriesDrag() {
    document.querySelectorAll('.tc-hair-stories__track').forEach(function (track) {
      var isDown = false;
      var startX;
      var scrollLeft;

      track.addEventListener('mousedown', function (e) {
        isDown = true;
        track.classList.add('tc-is-dragging');
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        e.preventDefault();
      });

      track.addEventListener('mouseleave', function () {
        isDown = false;
        track.classList.remove('tc-is-dragging');
      });

      track.addEventListener('mouseup', function () {
        isDown = false;
        track.classList.remove('tc-is-dragging');
      });

      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.6;
        track.scrollLeft = scrollLeft - walk;
      });
    });
  }

  /* ----------------------------------------------------------
     HAIR STORIES — Nav button scroll
  ---------------------------------------------------------- */
  function initHairStoriesNav() {
    document.querySelectorAll('.tc-hair-stories__nav').forEach(function (nav) {
      var section = nav.closest('.tc-hair-stories');
      if (!section) return;
      var track = section.querySelector('.tc-hair-stories__track');
      if (!track) return;

      var prevBtn = nav.querySelector('.tc-hair-stories__btn--prev');
      var nextBtn = nav.querySelector('.tc-hair-stories__btn--next');

      var cardWidth = function () {
        var card = track.querySelector('.tc-hair-story__card');
        return card ? card.offsetWidth + 16 : 320;
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        });
      }
    });
  }

  /* ----------------------------------------------------------
     BEST SELLERS — Mobile horizontal drag (if slider not used)
  ---------------------------------------------------------- */
  function initBestSellersDrag() {
    document.querySelectorAll('.tc-best-sellers__slider-wrapper').forEach(function (wrapper) {
      var isDown = false;
      var startX;
      var scrollLeft;

      wrapper.addEventListener('mousedown', function (e) {
        isDown = true;
        startX = e.pageX - wrapper.offsetLeft;
        scrollLeft = wrapper.scrollLeft;
        e.preventDefault();
      });

      wrapper.addEventListener('mouseleave', function () { isDown = false; });
      wrapper.addEventListener('mouseup', function () { isDown = false; });

      wrapper.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var x = e.pageX - wrapper.offsetLeft;
        wrapper.scrollLeft = scrollLeft - (x - startX) * 1.5;
      });
    });
  }

  /* ----------------------------------------------------------
     SHOPPABLE VIDEOS — Video controls & Drawer toggle
  ---------------------------------------------------------- */
  function initShoppableVideos() {
    var sections = document.querySelectorAll('.tc-hair-stories-section');
    sections.forEach(function (section) {
      
      // Mute Toggle
      var muteBtns = section.querySelectorAll('.tc-hs-mute-btn');
      muteBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var media = btn.closest('.tc-hair-story__media');
          var video = media ? media.querySelector('video') : null;
          if (!video) return;
          
          video.muted = !video.muted;
          btn.querySelector('.tc-icon-mute').style.display = video.muted ? 'inline-block' : 'none';
          btn.querySelector('.tc-icon-unmute').style.display = video.muted ? 'none' : 'inline-block';
        });
      });

      // Play/Pause Toggle
      var playBtns = section.querySelectorAll('.tc-hs-play-btn');
      playBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var media = btn.closest('.tc-hair-story__media');
          var video = media ? media.querySelector('video') : null;
          if (!video) return;

          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
          btn.querySelector('.tc-icon-pause').style.display = video.paused ? 'none' : 'inline-block';
          btn.querySelector('.tc-icon-play').style.display = video.paused ? 'inline-block' : 'none';
        });
      });

      // Video click to toggle play
      var videos = section.querySelectorAll('.tc-hs-video');
      videos.forEach(function (video) {
        video.addEventListener('click', function () {
          var media = video.closest('.tc-hair-story__media');
          var playBtn = media ? media.querySelector('.tc-hs-play-btn') : null;
          if (playBtn) playBtn.click();
        });
      });

      // Drawer Toggle
      var drawerToggles = section.querySelectorAll('.tc-hs-drawer__toggle');
      drawerToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var drawer = toggle.closest('.tc-hs-drawer');
          if (drawer) {
            drawer.classList.toggle('is-expanded');
          }
        });
      });

    });
  }

  /* ----------------------------------------------------------
     PRESS LOGOS — Intersection observer entrance animation
  ---------------------------------------------------------- */
  function initPressLogosAnimation() {
    if (!('IntersectionObserver' in window)) return;
    var logos = document.querySelectorAll('.tc-press__logo-item');
    if (!logos.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.animation = 'tc-logo-fade-in 0.5s ease forwards';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    logos.forEach(function (logo, i) {
      logo.style.opacity = '0';
      logo.style.animationDelay = (i * 0.08) + 's';
      observer.observe(logo);
    });

    // Inject keyframe if not already present
    if (!document.getElementById('tc-logo-keyframe')) {
      var style = document.createElement('style');
      style.id = 'tc-logo-keyframe';
      style.textContent = '@keyframes tc-logo-fade-in { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }';
      document.head.appendChild(style);
    }
  }

  /* ----------------------------------------------------------
     INIT — Run all initialisers after DOM is ready
  ---------------------------------------------------------- */
  function init() {
    initHairStoriesDrag();
    initHairStoriesNav();
    initBestSellersDrag();
    initShoppableVideos();
    initPressLogosAnimation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor support — re-init when sections are added/reloaded
  document.addEventListener('shopify:section:load', function () {
    init();
  });

}());
